// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1AuQ3","footer":"ChangeClinic_footer__1eIEF"};